// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f27114f","453":"59ff477a","667":"feb997be"}[chunkId] + ".chunk.js";
};